import Vue from 'vue'
import VueRouter from 'vue-router'
import Download from "../views/Download.vue";
import DownloadAdmin from "../views/DownloadAdmin.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/documents/:name',
    name: 'Download',
    component: Download
  },
  {
    path: '/admin/documents/:name',
    name: 'Download Admin',
    component: DownloadAdmin
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
